import * as React from 'react';
import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';
import { cn } from '@/lib/cn';

export interface LinkEditorProps extends React.ComponentProps<'div'> {
  defaultUrl?: string;
  defaultText?: string;
  onSave: (url: string, text?: string) => void;
  onCancel: () => void;
}

export const LinkEditBlock = ({
  onSave,
  defaultUrl,
  defaultText,
  className,
  onCancel,
}: LinkEditorProps) => {
  const formRef = React.useRef<HTMLDivElement>(null);
  const [url, setUrl] = React.useState(defaultUrl || '');
  const [text, setText] = React.useState(defaultText || '');

  const handleSave = React.useCallback(
    (e: React.MouseEvent<HTMLButtonElement>) => {
      e.preventDefault();
      if (formRef.current) {
        const isValid = Array.from(
          formRef.current.querySelectorAll('input')
        ).every((input) => input.checkValidity());

        if (isValid) {
          onSave(url, text);
        } else {
          formRef.current.querySelectorAll('input').forEach((input) => {
            if (!input.checkValidity()) {
              input.reportValidity();
            }
          });
        }
      }
    },
    [onSave, url, text]
  );

  return (
    <div ref={formRef}>
      <div className={cn('space-y-4', className)}>
        <div className='space-y-1'>
          <Label>URL</Label>
          <Input
            type='url'
            required
            placeholder='Infoga URL'
            value={url}
            onChange={(e) => setUrl(e.target.value)}
          />
        </div>

        <div className='space-y-1'>
          <Label>Text (valfri)</Label>
          <Input
            type='text'
            placeholder='Enter display text'
            value={text}
            onChange={(e) => setText(e.target.value)}
          />
        </div>

        <div className='flex justify-end space-x-2'>
          <Button type='button' variant='outline' onClick={onCancel}>
            Avbryt
          </Button>
          <Button type='button' onClick={handleSave} disabled={!url}>
            Spara
          </Button>
        </div>
      </div>
    </div>
  );
};
